import HTTP from "../HTTP";
import Jsona from "jsona";
import APIMixin from "@/mixins/APIMixin";
import notificationList from "@/store/modules/notifications";
import paramsHelpers from "../helpers/params";

const requestBody = APIMixin.methods;

const dataFormatter = new Jsona();
const currentTime = new Date().toISOString();

export default {
  async create(payload) {
    const included_states = requestBody.build_includes(
      payload.states,
      "states"
    );
    const included_cities = requestBody.build_includes(
      payload.cities,
      "cities"
    );
    const included_districts = requestBody.build_includes(
      payload.districts,
      "districts"
    );
    const included_users = requestBody.build_includes(
      payload.users,
      payload.user_type
    );

    let data = {
      data: {
        type: "notifications",
        attributes: {
          title: payload.title,
          message: payload.message,
          scheduled_time: payload.timestamp,
          account_status: payload.account_status,
          accountable_status: payload.accountable_status
        }
      },
      included: [
        ...included_cities,
        ...included_users,
        ...included_districts,
        ...included_states
      ]
    };
    try {
      return await HTTP.normal.post(
        `/notifications/${payload.user_type}`,
        data
      );
    } catch (e) {
      throw "Ocorreu um problema no envio da notificação";
    }
  },

  async index(numberPage, field_sort, textSearch) {
    try {
      let search =
        textSearch.length > 3 ? `&filter[text_search]=${textSearch}` : "";
      let page = `page[number]=${numberPage}`;
      let sort = field_sort.length > 0 ? `&sort=${field_sort}` : "";

      let results = await HTTP.normal.get(
        `/notifications?${page}${search}${sort}&filter[trigger_resource_type]=null`
      );

      return {
        data: dataFormatter.deserialize(results.data),
        meta: results.data.meta,
        totalItems: results.data.meta.record_count
      };
    } catch (e) {
      throw "Ocorreu um erro ao listar as notificações!";
    }
  },

  async listAll() {
    try {
      let textSearch = notificationList.state.search;
      let number = notificationList.state.options.page;
      let size = notificationList.state.options.itemsPerPage;
      let type = notificationList.state.notificationType;
      let fields = notificationList.state.options.sortBy;
      let desc = notificationList.state.options.sortDesc;
      let filters = [];

      if (type == "sent") {
        filters = [
          {
            name: "trigger_resource_type",
            value: "null"
          },
          {
            name: "text_search",
            value: textSearch
          },
          {
            name: "sent_before_than",
            value: currentTime
          }
        ];
      } else {
        filters = [
          {
            name: "trigger_resource_type",
            value: "null"
          },
          {
            name: "text_search",
            value: textSearch
          },
          {
            name: "scheduled_for_greater_than",
            value: currentTime
          }
        ];
      }

      let dataParams = {
        filters,
        sort: { fields, desc },
        pagination: { number, size }
      };

      let params = paramsHelpers.buildParams(dataParams);

      let url = `/notifications${params}`;

      let results = await HTTP.normal.get(url);

      return {
        data: dataFormatter.deserialize(results.data),
        meta: results.data.meta,
        totalItems: results.data.meta.record_count
      };
    } catch (e) {
      throw e;
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/notifications.js